import { render, staticRenderFns } from "./Newsrecommendation.vue?vue&type=template&id=8ab0639a&scoped=true&"
import script from "./Newsrecommendation.vue?vue&type=script&lang=js&"
export * from "./Newsrecommendation.vue?vue&type=script&lang=js&"
import style0 from "./Newsrecommendation.vue?vue&type=style&index=0&id=8ab0639a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab0639a",
  null
  
)

export default component.exports